import icons from '../../markons/markons'

export const CURRENCY_MAP: Record<string, string> = {
    USD: icons.faDollar,
    CAD: icons.faDollar,
    MXN: icons.faDollar,
    AUD: icons.faDollar,
    SGD: icons.faDollar,
    EUR: icons.faEuroSign,
    GBP: icons.faPoundSign,
    INR: icons.faRupeeSign,
    JPY: icons.faYenSign,
}

export function getCurrencyIcon(currency: string|undefined) {
    currency ??= window.company?.currencyCode
    if(!currency) return icons.faMoneyBillWave
    return CURRENCY_MAP[currency] || icons.faMoneyBillWave;
}

// From Util::currencyFormatMulti
export type DollarAmount = {
    decimal: string
    currency: string
    value: number
    formatted: string
}
